var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.45 0.900391C9.603 0.900391 0 10.5034 0 22.3504C0 33.1051 7.92165 41.9837 18.2441 43.5347V28.0346H12.936V22.3966H18.2441V18.6445C18.2441 12.4322 21.2702 9.70644 26.433 9.70644C28.9047 9.70644 30.2132 9.88959 30.8319 9.97374V14.8957H27.3108C25.1196 14.8957 24.354 16.973 24.354 19.316V22.3982H30.7775L29.9063 28.0363H24.354V43.5826C34.8233 42.1603 42.9 33.209 42.9 22.3504C42.9 10.5034 33.297 0.900391 21.45 0.900391Z",
    fill: "#071D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9,
    height: 42.9,
    fill: "white",
    transform: "translate(0 0.900391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.70a1506339ab2928b5ec30b5af951762.svg";
export { ForwardRef as ReactComponent };